import { render, staticRenderFns } from "./SurveyClipboardButton.vue?vue&type=template&id=0c75bd94&scoped=true"
import script from "./SurveyClipboardButton.vue?vue&type=script&lang=js"
export * from "./SurveyClipboardButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c75bd94",
  null
  
)

export default component.exports